import { ROUTES } from "@navigation";
import { STRING } from "@constants";

export interface MenuItem {
  label: string;
  icon?: string;
  path?: string;
  items?: MenuItem[];
  command?: () => void;
  className?: string;
}

export function getAdminSidebarMenus(
  navigate: (path: string) => void,
  currentPath: string,
): {
  menuItems: MenuItem[];
  panelMenuItems: MenuItem[];
  menuItemsSecond: MenuItem[];
  panelMenuItemsSecond: MenuItem[];
} {
  const buildPath = (subPath: string) => `${ROUTES.ADMIN}/${subPath}`;
  const buildUnitPath = (subPath: string) =>
    `${ROUTES.ADMIN}/${ROUTES.UNITS}/${subPath}`;
  const buildSettingPath = (subPath: string) =>
    `${ROUTES.ADMIN}/${ROUTES.WEBSITE_SETTINGS}/${subPath}`;
  const isActive = (path: string) =>
    currentPath === path ? "p-menuitem-active" : "";

  return {
    menuItems: [
      {
        label: STRING.SIDEBAR.DASHBOARD,
        icon: "pi pi-home",
        command: () => navigate(buildPath(ROUTES.DASHBOARD)),
        className: isActive(buildPath(ROUTES.DASHBOARD)),
      },
    ],
    panelMenuItems: [
      {
        label: STRING.SIDEBAR.UNITS,
        icon: "pi pi-box",
        items: [
          {
            label: "All Units",
            icon: "pi pi-list",
            path: buildUnitPath(ROUTES.ALL),
            className: isActive(buildUnitPath(ROUTES.ALL)),
          },
        ],
      },
    ],
    menuItemsSecond: [
      {
        label: STRING.SIDEBAR.CUSTOMERS,
        icon: "pi pi-users",
        command: () => navigate(buildPath(ROUTES.CUSTOMERS)),
        className: isActive(buildPath(ROUTES.CUSTOMERS)),
      },
      {
        label: STRING.SIDEBAR.CONTRACTS,
        icon: "pi pi-file",
        command: () => navigate(buildPath(ROUTES.CONTRACTS)),
        className: isActive(buildPath(ROUTES.CONTRACTS)),
      },
      {
        label: STRING.SIDEBAR.LOCATIONS,
        icon: "pi pi-map-marker",
        command: () => navigate(buildPath(ROUTES.LOCATIONS)),
        className: isActive(buildPath(ROUTES.LOCATIONS)),
      },
      {
        label: STRING.SIDEBAR.INSURANCES,
        icon: "pi pi-briefcase",
        command: () => navigate(buildPath(ROUTES.INSURANCES)),
        className: isActive(buildPath(ROUTES.INSURANCES)),
      },
    ],
    panelMenuItemsSecond: [
      {
        label: "Website Settings",
        icon: "pi pi-globe",
        items: [
          // {
          //   label: "Unit Descriptions Setup",
          //   icon: "pi pi-file-edit",
          //   path: buildSettingPath(ROUTES.WEBSITE_UNIT_DESCRIPTIONS),
          //   className: isActive(
          //     buildSettingPath(ROUTES.WEBSITE_UNIT_DESCRIPTIONS),
          //   ),
          // },
          // {
          //   label: "Website Graphics",
          //   icon: "pi pi-palette",
          //   path: buildSettingPath(ROUTES.WEBSITE_GRAPHICS),
          //   className: isActive(buildSettingPath(ROUTES.WEBSITE_GRAPHICS)),
          // },
          {
            label: STRING.SIDEBAR.SYNC,
            icon: "pi pi-sync",
            path: buildSettingPath(ROUTES.SYNC),
            className: isActive(buildSettingPath(ROUTES.SYNC)),
          },
          {
            label: "Unit Description",
            icon: "pi pi-align-left",
            path: buildSettingPath(ROUTES.UNITDESCRIPTION),
            className: isActive(buildSettingPath(ROUTES.UNITDESCRIPTION)),
          },
          {
            label: "Unit Sizes",
            icon: "pi pi-arrows-alt",
            path: buildSettingPath(ROUTES.UNITSIZES),
            className: isActive(buildSettingPath(ROUTES.UNITSIZES)),
          },
          {
            label: "Unit Categories",
            icon: "pi pi-tags",
            path: buildSettingPath(ROUTES.UNITCATEGORY),
            className: isActive(buildSettingPath(ROUTES.UNITCATEGORY)),
          },
        ],
      },
    ],
  };
}
